const CACHE_ID = process.env.NEXT_PUBLIC_CACHE_VERSION
  ? `${process.env.NEXT_PUBLIC_CACHE_VERSION}@`
  : '';

const withRuntimeCaching = (runtimeCaching) => {
  const cacheId = CACHE_ID;
  return {
    cacheId,
    runtimeCaching: runtimeCaching.map((config) => {
      if (cacheId) {
        config.options.cacheName = `${cacheId}${config.options.cacheName}`;
      }
      return config;
    }, {}),
  };
};

const defaultModule = (module.exports = withRuntimeCaching);
defaultModule.CACHE_ID = CACHE_ID;
